"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Help = exports.Label = exports.Adornment = exports.InputWrapper = exports.TextArea = exports.Input = exports.Legend = exports.Fieldset = exports.Wrapper = exports.Container = void 0;

var React = _interopRequireWildcard(require("react"));

var _polished = require("polished");

var _styled = _interopRequireWildcard(require("../styled"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var EASING = 'cubic-bezier(.25, .8, .25, 1)';

var Container = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 200px;\n"])));

exports.Container = Container;

var Wrapper = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  max-width: fill-available;\n\n  ", "\n"])), function (props) {
  return props.hasLabel && (0, _styled.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      margin-top: 0.85ex;\n    "])));
});

exports.Wrapper = Wrapper;

var Fieldset = _styled["default"].fieldset(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border-radius: 4px;\n  border-style: solid;\n  border-width: 1px;\n  top: -0.65ex;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  pointer-events: none;\n\n  transition: padding-left 200ms ", " 0ms, border-color 200ms ", " 0ms;\n\n  border-color: ", ";\n"])), EASING, EASING, function (props) {
  return props.focused ? props.theme.primary : (0, _polished.transparentize)(0.2, props.theme.foreground);
});

exports.Fieldset = Fieldset;

var Legend = _styled["default"].legend(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  transition: width 200ms ", " 0ms;\n  padding: 0;\n  width: 0;\n"])), EASING);

exports.Legend = Legend;

var Input = _styled["default"].input(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-family: inherit;\n  background: none;\n  border: none;\n  height: 2ex;\n  padding: 0.95ex 0.625em;\n  margin: 0.5ex 0 0;\n  min-width: 0;\n  width: fill-available;\n  display: block;\n  color: ", ";\n  outline: none;\n  font-size: inherit;\n\n  /* Fixes weird sizing issues on macOS */\n  -webkit-appearance: textfield;\n\n  &:focus {\n    outline: none;\n  }\n\n  /*\n    TODO fix me, because we're being rushed again\n  */\n  option {\n    background-color: ", ";\n    border: none;\n    outline: none;\n  }\n\n  ", "\n  ", "\n"])), function (props) {
  return props.theme.foreground;
}, function (props) {
  return props.theme.background;
}, function (props) {
  return props.hasLeftDecor && (0, _styled.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      padding-left: 0.2em;\n    "])));
}, function (props) {
  return props.hasRightDecor && (0, _styled.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      padding-right: 0.2em;\n    "])));
});

exports.Input = Input;
var TextArea = (0, _styled["default"])(Input).attrs({
  as: 'textarea'
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  height: 16ex;\n"])));
exports.TextArea = TextArea;

var InputWrapper = _styled["default"].div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n"])));

exports.InputWrapper = InputWrapper;

var Adornment = _styled["default"].div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-basis: auto;\n  padding-top: 1.425ex;\n  min-width: fit-content;\n  font-size: inherit;\n\n  ", "\n\n  color: ", ";\n\n  &:empty {\n    display: none;\n  }\n"])), function (props) {
  return props.side === 'left' ? (0, _styled.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n          padding-left: 0.625em;\n        "]))) : (0, _styled.css)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n          padding-right: 0.625em;\n        "])));
}, function (props) {
  return (0, _polished.transparentize)(0.4, props.theme.foreground);
});

exports.Adornment = Adornment;

var Label = _styled["default"].label(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  transition: transform 200ms ", " 0ms, color 175ms ", " 0ms;\n\n  position: absolute;\n  line-height: 1.15;\n  pointer-events: none;\n  transform-origin: 0 center;\n\n  font-family: ", ";\n  color: ", ";\n  transform: ", ";\n\n  ", "\n"])), EASING, EASING, function (props) {
  return props.theme.fonts.label;
}, function (props) {
  return props.focused ? props.theme.foreground : (0, _polished.transparentize)(0.2, props.theme.foreground);
}, function (props) {
  return props.focused || props.hasValue || props.shrinked ? 'translate(0.9em, -0.675ex) scale(0.75)' : 'translate(0.625em, 1.425ex) scale(1)';
}, (0, _polished.ellipsis)('90%'));

exports.Label = Label;

var Help = _styled["default"].div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  font-size: 80%;\n  padding: 0.35rem;\n\n  ", "\n"])), function (props) {
  return (0, _styled.css)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    font-family: ", ";\n    color: ", ";\n  "])), props.theme.fonts.help, (0, _polished.transparentize)(0.2, props.theme.foreground));
});
/**
 * The text field is slightly fancier version of a `<input>` component.
 *
 * Any props not covered here are passed through to the underlying `<input>` component.
 *
 */


exports.Help = Help;

var TextField = function TextField(_ref) {
  var label = _ref.label,
      value = _ref.value,
      help = _ref.help,
      _ref$left = _ref.left,
      left = _ref$left === void 0 ? null : _ref$left,
      _ref$right = _ref.right,
      right = _ref$right === void 0 ? null : _ref$right,
      _ref$shrinked = _ref.shrinked,
      shrinked = _ref$shrinked === void 0 ? false : _ref$shrinked,
      _ref$multipleLines = _ref.multipleLines,
      multipleLines = _ref$multipleLines === void 0 ? false : _ref$multipleLines,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      className = _ref.className,
      style = _ref.style,
      rest = _objectWithoutProperties(_ref, ["label", "value", "help", "left", "right", "shrinked", "multipleLines", "onBlur", "onFocus", "className", "style"]);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];

  var _React$useState3 = React.useState('0'),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      legendWidth = _React$useState4[0],
      setLegendWidth = _React$useState4[1];

  var inputRef = React.useRef(null);
  var labelRef = React.useRef(null);
  var blurHandler = React.useCallback(function (e) {
    if (onBlur) onBlur(e);
    setFocused(false);
  }, [setFocused, onBlur]);
  var focusHandler = React.useCallback(function (e) {
    if (onFocus) onFocus(e);
    setFocused(true);
  }, [setFocused, onFocus]);
  var hasValue = inputRef.current ? inputRef.current.value !== '' : value !== '';
  React.useEffect(function () {
    if (label) {
      labelRef.current && setLegendWidth("calc(".concat(labelRef.current.offsetWidth * 0.75, "px + 0.5em)"));
    } else {
      setLegendWidth('0');
    }
  }, [label]);
  var shrink = !!(shrinked || hasValue || focused || right || left);
  var InputElement = multipleLines ? TextArea : Input;
  return /*#__PURE__*/React.createElement(Container, {
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(Wrapper, {
    hasLabel: !!label
  }, /*#__PURE__*/React.createElement(Label, {
    focused: focused,
    hasValue: hasValue,
    shrinked: shrink,
    ref: labelRef
  }, label), /*#__PURE__*/React.createElement(InputWrapper, null, /*#__PURE__*/React.createElement(Adornment, {
    side: "left"
  }, left), /*#__PURE__*/React.createElement(InputElement, _extends({}, rest, {
    value: value,
    focused: focused,
    onBlur: blurHandler,
    onFocus: focusHandler,
    hasValue: hasValue,
    hasLeftDecor: !!left,
    hasRightDecor: !!right,
    ref: inputRef
  })), /*#__PURE__*/React.createElement(Adornment, {
    side: "right"
  }, right)), /*#__PURE__*/React.createElement(Fieldset, {
    focused: focused,
    style: {
      paddingLeft: shrink ? '0.6em' : "calc(".concat(legendWidth, " / 2)")
    },
    hasValue: hasValue
  }, /*#__PURE__*/React.createElement(Legend, {
    style: {
      width: shrink ? legendWidth : 0
    }
  }, "\u200B"))), help && /*#__PURE__*/React.createElement(Help, null, help));
};

var _default = TextField;
exports["default"] = _default;